import * as React from "react";
import { Image } from "@models/image";
import {Modal, Row} from "antd";
import ImagesItem from "@components/images/Item";
import Message from "@constants/message";
import {FormattedMessage, injectIntl, intlShape } from 'react-intl';


type Props = {
    data: Image[];
    deleteFn?: (item: Image) => void;
    onImageClick?:(item: Image) => void;
};

const ImagesList: React.FC<Props> = props => {
    const {data, deleteFn, onImageClick, intl} = props;
    const { formatMessage } = intl;


    const deleteImage = (item:Image):void =>{
        Modal.confirm({
            content : formatMessage({
                id: "app.general_delete_warning",
                defaultMessage : Message.Warning.Delete,
            }),
            okText:formatMessage({
                id: "app.delete",
                defaultMessage : "Delete",
            }),
            cancelText:formatMessage({
                id: "app.cancel",
                defaultMessage : "Cancel",
            }),
            className: "delete-confirm-dialog",
            onOk : () => deleteFn(item),
        });
    };


    return (
    <Row gutter={24} className={'images-list'}>
      {data.map(image => (
            <ImagesItem
              onClick={onImageClick}
              image={image}
              key={image.id}
              canEdit={true}
              canDelete={true}
              deleteFn={deleteImage}
            />
      ))}
    </Row>
  );
};

export default injectIntl(ImagesList);
